module.exports = __webpack_public_path__ + "img/card-global.f81c94b9.svg";